import { FunctionComponent, useEffect } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'

import { useAuthContext } from 'auth/context/useAuthContext'
import { AuthErrorEnum } from 'auth/types'

import { ErrorLayout } from 'layout/ErrorLayout'
import { redirectToCharlie } from 'utils/redirectToCharlie'
import { redirectToCharlieErrorRoute } from 'utils/redirectToCharlieErrorRoute'

import { Message } from '../../styled/message'

export const AuthError: FunctionComponent = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const status = searchParams.get('status')

  useEffect(() => {
    // If no status is provided, redirect to Charlie
    if (!status) {
      redirectToCharlie()
    }
  }, [status, navigate])

  const getContent = () => {
    switch (status) {
      case AuthErrorEnum.EXPIRED:
        return {
          action: 'redirect',
          status: 403,
          shortCode: 'token_expired',
        }
      case AuthErrorEnum.LOGOUT:
        return {
          action: 'errorPage',
          title: 'All done',
          description: 'You have been successfully logged out.',
        }
      case AuthErrorEnum.INVALID:
        return {
          action: 'redirect',
          status: 403,
          shortCode: 'token_invalid',
        }
      case AuthErrorEnum.SETUP:
        return {
          action: 'redirect',
          status: 403,
          shortCode: 'token_setup',
        }
      default:
        return {
          action: 'errorPage',
          title: 'Oops',
          description: 'Something went wrong. Go to Charlie',
        }
    }
  }

  const { charlieUser } = useAuthContext()
  const copy = getContent()

  if (copy.action === 'redirect') {
    if (charlieUser?.companyDomain) {
      redirectToCharlieErrorRoute(charlieUser, copy)
    } else {
      redirectToCharlie()
    }
    return null
  }
  return (
    <ErrorLayout>
      <h1>{copy.title}</h1>
      <Message>{copy.description}</Message>
    </ErrorLayout>
  )
}
